(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-desktop"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.innerWidth <= 1024;

    // Only set up desktop hover menu functionality for desktop
    if (!isMobile) {
      const productLink = document.getElementById('product-link-desktop');
      const productHoverMenu = document.getElementById('product-hover-menu');
      const navbarHeader = document.getElementById('navbar-header-desktop');

      if (!navbarHeader) return;

      const showNavbarHeader = () => {
        navbarHeader.style.height = 'auto';
        navbarHeader.style.backgroundColor = '#231F2080';
        navbarHeader.style.borderBottom = 'none';
        navbarHeader.style.backdropFilter = 'blur(120px)';
        if (productHoverMenu) {
          productHoverMenu.classList.add('open');
        }
      };

      const hideNavbarHeader = () => {
        navbarHeader.style.height = '80px'; // Reset to original height
        navbarHeader.style.backgroundColor = 'transparent';
        navbarHeader.style.borderBottom = 'none';
        navbarHeader.style.backdropFilter = 'none';
        if (productHoverMenu) {
          productHoverMenu.classList.remove('open');
        }
      };

      productLink?.addEventListener('mouseenter', showNavbarHeader);
      productLink?.addEventListener('mouseleave', hideNavbarHeader);

      productHoverMenu?.addEventListener('mouseenter', showNavbarHeader);
      productHoverMenu?.addEventListener('mouseleave', hideNavbarHeader);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mobile"] && !Shopify.designMode) return;
  try {
    // Mobile burger menu functionality
  document.addEventListener('DOMContentLoaded', function () {
    const burgerMenu = document.getElementById('burger-menu-mobile');
    const mainNav = document.getElementById('main-nav-mobile');
    const productHoverMenu = document.getElementById('product-hover-menu-desktop');
    const productsPopup = document.getElementById('products-popup');
    const productsTrigger = document.getElementById('products-trigger');
    const productsBackBtn = document.getElementById('products-back-btn');
    const mainNavList = document.getElementById('main-nav-list-mobile');

    // Set up burger menu click handler
    if (burgerMenu && mainNav) {
      burgerMenu.addEventListener('click', function () {
        mainNav.classList.toggle('open');
        burgerMenu.classList.toggle('open');

        // Close products popup when main nav is closed
        if (!mainNav.classList.contains('open')) {
          productsPopup.classList.remove('open');
          mainNavList.classList.remove('hidden');
        }

        if (productHoverMenu) {
          productHoverMenu.classList.remove('open');
        }
      });
    }

    // Products trigger click handler
    if (productsTrigger) {
      productsTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        productsPopup.classList.add('open');
        mainNavList.classList.add('hidden');
      });
    }

    // Products back button click handler
    if (productsBackBtn) {
      productsBackBtn.addEventListener('click', function () {
        productsPopup.classList.remove('open');
        mainNavList.classList.remove('hidden');
      });
    }

    // Close mobile nav when clicking outside
    document.addEventListener('click', function (event) {
      if (
        mainNav &&
        mainNav.classList.contains('open') &&
        !mainNav.contains(event.target) &&
        !burgerMenu.contains(event.target)
      ) {
        mainNav.classList.remove('open');
        burgerMenu.classList.remove('open');
        productsPopup.classList.remove('open');
        mainNavList.classList.remove('hidden');
      }
    });

    // Close mobile nav with escape key
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && mainNav && mainNav.classList.contains('open')) {
        mainNav.classList.remove('open');
        burgerMenu.classList.remove('open');
        productsPopup.classList.remove('open');
        mainNavList.classList.remove('hidden');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
